var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "miku__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "nav",
        {
          staticClass:
            "navbar navbar-expand-lg navbar-light bg-light shadow-sm bg-white"
        },
        [
          _c(
            "div",
            { staticClass: "container p-0" },
            [
              _c(
                "router-link",
                { staticClass: "navbar-brand", attrs: { to: "/", tag: "a" } },
                [
                  _c("img", {
                    style: _vm.$mq.phone ? "padding: 0 1rem" : "",
                    attrs: {
                      src: "/static/img/recruitment/MIKU-AGENCY-LOGO.png",
                      height: "50",
                      alt: ""
                    }
                  })
                ]
              )
            ],
            1
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "container" },
      [
        _c(
          "section",
          { staticClass: "py-1", attrs: { id: "header-maid-banner" } },
          [
            _c("b-img", {
              attrs: {
                src:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/recruitment/maid_banner_1.png",
                fluid: "",
                alt: "..."
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("section", [
          _c("div", { staticClass: "row no-gutters" }, [
            _c(
              "div",
              {
                staticClass: "col-12 col-md-6 col-lg-6 p-2",
                attrs: { id: "form-maid-recruitment" }
              },
              [
                _c("div", { staticClass: "card m-0" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex justify-content-between" }, [
                    _c("p", { staticClass: "font-weight-bolder p-3" }, [
                      _vm._v("ข้อมูลการติดต่อ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "scroll-to",
                            rawName: "v-scroll-to",
                            value: {
                              el: "#what-a-service",
                              offset: _vm.$mq.phone ? -110 : -230
                            },
                            expression:
                              "{el:'#what-a-service', offset: $mq.phone ? -110 : -230}"
                          }
                        ],
                        attrs: { href: "#" }
                      },
                      [
                        _c(
                          "button",
                          { staticClass: "btn btn-sm btn-outline-info mx-1" },
                          [
                            _vm._v(
                              "\n                                    รายละเอียดบริการจัดหา\n                                "
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "px-3" },
                    [
                      _c(
                        "b-form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.onSubmit.apply(null, arguments)
                            },
                            reset: function($event) {
                              $event.preventDefault()
                              return _vm.onReset.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { id: "input-group-name" } },
                            [
                              _c("label", { attrs: { for: "input-1" } }, [
                                _vm._v("ชื่อผู้ติดต่อ "),
                                _c("span", { staticClass: "text-danger" }, [
                                  _vm._v("*")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-form-input", {
                                attrs: {
                                  type: "text",
                                  id: "input-1",
                                  placeholder: "",
                                  required: ""
                                },
                                model: {
                                  value: _vm.formMaidRecruitment.name,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formMaidRecruitment,
                                      "name",
                                      $$v
                                    )
                                  },
                                  expression: "formMaidRecruitment.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            { attrs: { id: "input-group-tel" } },
                            [
                              _c("label", { attrs: { for: "input-3" } }, [
                                _vm._v("เบอร์โทร "),
                                _c("span", { staticClass: "text-danger" }, [
                                  _vm._v("*")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-form-input", {
                                attrs: {
                                  type: "tel",
                                  id: "input-3",
                                  placeholder: "",
                                  required: ""
                                },
                                model: {
                                  value: _vm.formMaidRecruitment.tel,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formMaidRecruitment,
                                      "tel",
                                      $$v
                                    )
                                  },
                                  expression: "formMaidRecruitment.tel"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            { attrs: { id: "input-group-salary" } },
                            [
                              _c("label", { attrs: { for: "input-2" } }, [
                                _vm._v("ช่วงเงินเดือน "),
                                _c("span", { staticClass: "text-danger" }, [
                                  _vm._v("*")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-form-select",
                                {
                                  staticClass: "mb-3",
                                  attrs: { required: "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "first",
                                      fn: function() {
                                        return [
                                          _c(
                                            "b-form-select-option",
                                            {
                                              attrs: {
                                                value: null,
                                                disabled: ""
                                              }
                                            },
                                            [_vm._v("กรุณาเลือกช่วงเงินเดือน")]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ]),
                                  model: {
                                    value: _vm.optionSalary,
                                    callback: function($$v) {
                                      _vm.optionSalary = $$v
                                    },
                                    expression: "optionSalary"
                                  }
                                },
                                [
                                  _vm._v(" "),
                                  _vm._l(
                                    [
                                      "13,000-15,000",
                                      "15,000-18,000",
                                      "18,000-20,000"
                                    ],
                                    function(item, index) {
                                      return _c(
                                        "b-form-select-option",
                                        { key: index, attrs: { value: index } },
                                        [_vm._v(_vm._s(item))]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-form-group", {
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var ariaDescribedby = ref.ariaDescribedby
                                  return [
                                    _c("label", [
                                      _vm._v("ประเภทบริการที่ต้องการ "),
                                      _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [_vm._v("*")]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "row no-gutters" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 col-md-6 col-lg-6"
                                          },
                                          [
                                            _c(
                                              "b-form-radio",
                                              {
                                                staticClass: "mt-2",
                                                attrs: {
                                                  "aria-describedby": ariaDescribedby,
                                                  name: "service-radios",
                                                  value:
                                                    "คุณแม่บ้าน ทําความสะอาด",
                                                  required: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.formMaidRecruitment
                                                      .service_required,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formMaidRecruitment,
                                                      "service_required",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formMaidRecruitment.service_required"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                คุณแม่บ้าน ทําความสะอาด\n                                            "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-radio",
                                              {
                                                staticClass: "mt-2",
                                                attrs: {
                                                  "aria-describedby": ariaDescribedby,
                                                  name: "service-radios",
                                                  value:
                                                    "คุณแม่บ้าน กึ่งแม่ครัว",
                                                  required: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.formMaidRecruitment
                                                      .service_required,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formMaidRecruitment,
                                                      "service_required",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formMaidRecruitment.service_required"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                คุณแม่บ้าน กึ่งแม่ครัว\n                                            "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-radio",
                                              {
                                                staticClass: "mt-2",
                                                attrs: {
                                                  "aria-describedby": ariaDescribedby,
                                                  name: "service-radios",
                                                  value:
                                                    "คุณแม่บ้าน กึ่งพี่เลี้ยงเด็ก",
                                                  required: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.formMaidRecruitment
                                                      .service_required,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formMaidRecruitment,
                                                      "service_required",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formMaidRecruitment.service_required"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                คุณแม่บ้าน กึ่งพี่เลี้ยงเด็ก\n                                            "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-radio",
                                              {
                                                staticClass: "mt-2",
                                                attrs: {
                                                  "aria-describedby": ariaDescribedby,
                                                  name: "service-radios",
                                                  value:
                                                    "คุณแม่บ้าน กึ่งดูแลผู้สูงอายุ",
                                                  required: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.formMaidRecruitment
                                                      .service_required,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formMaidRecruitment,
                                                      "service_required",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formMaidRecruitment.service_required"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                คุณแม่บ้าน กึ่งดูแลผู้สูงอายุ\n                                            "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-radio",
                                              {
                                                staticClass: "mt-2",
                                                attrs: {
                                                  "aria-describedby": ariaDescribedby,
                                                  name: "service-radios",
                                                  value:
                                                    "คุณแม่บ้าน กึ่งดูแลผู้ป่วย",
                                                  required: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.formMaidRecruitment
                                                      .service_required,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formMaidRecruitment,
                                                      "service_required",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formMaidRecruitment.service_required"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                คุณแม่บ้าน กึ่งดูแลผู้ป่วย\n                                            "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 col-md-6 col-lg-6"
                                          },
                                          [
                                            _c(
                                              "b-form-radio",
                                              {
                                                staticClass: "mt-2",
                                                attrs: {
                                                  "aria-describedby": ariaDescribedby,
                                                  name: "service-radios",
                                                  value:
                                                    "คุณแม่บ้าน กึ่งดูแลสัตว์เลี้ยง",
                                                  required: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.formMaidRecruitment
                                                      .service_required,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formMaidRecruitment,
                                                      "service_required",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formMaidRecruitment.service_required"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                คุณแม่บ้าน กึ่งดูแลสัตว์เลี้ยง\n                                            "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-radio",
                                              {
                                                staticClass: "mt-2",
                                                attrs: {
                                                  "aria-describedby": ariaDescribedby,
                                                  name: "service-radios",
                                                  value: "พี่เลี้ยงเด็ก",
                                                  required: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.formMaidRecruitment
                                                      .service_required,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formMaidRecruitment,
                                                      "service_required",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formMaidRecruitment.service_required"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                พี่เลี้ยงเด็ก\n                                            "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-radio",
                                              {
                                                staticClass: "mt-2",
                                                attrs: {
                                                  "aria-describedby": ariaDescribedby,
                                                  name: "service-radios",
                                                  value:
                                                    "พนักงานดูแลผู้สูงอายุ",
                                                  required: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.formMaidRecruitment
                                                      .service_required,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formMaidRecruitment,
                                                      "service_required",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formMaidRecruitment.service_required"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                พนักงานดูแลผู้สูงอายุ\n                                            "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-radio",
                                              {
                                                staticClass: "mt-2",
                                                attrs: {
                                                  "aria-describedby": ariaDescribedby,
                                                  name: "service-radios",
                                                  value:
                                                    "พนักงานดูแลผู้ป่วย/ผู้ป่วยติดเตียง",
                                                  required: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.formMaidRecruitment
                                                      .service_required,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formMaidRecruitment,
                                                      "service_required",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formMaidRecruitment.service_required"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                พนักงานดูแลผู้ป่วย/ผู้ป่วยติดเตียง\n                                            "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-radio",
                                              {
                                                staticClass: "mt-2",
                                                attrs: {
                                                  "aria-describedby": ariaDescribedby,
                                                  name: "service-radios",
                                                  value: "งานคู่ สามี-ภรรยา",
                                                  required: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.formMaidRecruitment
                                                      .service_required,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formMaidRecruitment,
                                                      "service_required",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formMaidRecruitment.service_required"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                งานคู่ สามี-ภรรยา\n                                            "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            { attrs: { id: "input-group-province" } },
                            [
                              _c("label", { attrs: { for: "input-4" } }, [
                                _vm._v("จังหวัด "),
                                _c("span", { staticClass: "text-danger" }, [
                                  _vm._v("*")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-form-select",
                                {
                                  staticClass: "mb-3",
                                  attrs: { required: "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "first",
                                      fn: function() {
                                        return [
                                          _c(
                                            "b-form-select-option",
                                            {
                                              attrs: {
                                                value: null,
                                                disabled: ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "กรุณาเลือกจังหวัดที่ใช้บริการ"
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ]),
                                  model: {
                                    value: _vm.formMaidRecruitment.province,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formMaidRecruitment,
                                        "province",
                                        $$v
                                      )
                                    },
                                    expression: "formMaidRecruitment.province"
                                  }
                                },
                                [
                                  _vm._v(" "),
                                  _vm._l(_vm.provinces, function(item, index) {
                                    return _c(
                                      "b-form-select-option",
                                      { key: index, attrs: { value: item.id } },
                                      [_vm._v(_vm._s(item.name_th))]
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c("p", { staticClass: "m-0 text-warning" }, [
                              _vm._v("เงื่อนไขการให้บริการ")
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "m-0" }, [
                              _vm._v(
                                "บริการจัดหาคุณแม่บ้าน Miku จะเป็นเป็นตัวกลางในการจัดหาคุณแม่บ้านตามรายละเอียดและเงื่อนไขที่\n                                        คุณลูกค้าแจ้งมา โดยคุณแม่บ้านจะเป็นพนักงานหรือเป็นลูกจ้างประจำ\n                                        ของคุณลูกค้าโดยที่คุณลูกค้าสามารถตกลง สวัสดิการ เงินเดือน รายได้พิเศษ ฯลฯ\n                                        กับคุณแม่บ้านผู้สมัครได้โดยตรง"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "btn btn-info my-1",
                                  class: _vm.$mq.phone ? "btn-block" : "btn-sm",
                                  attrs: { type: "submit" }
                                },
                                [_vm._v("ส่งคำขอรับบริการจัดหา")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "https://lin.ee/2oiTubz",
                                    target: "_blank",
                                    id: "blinking-text"
                                  }
                                },
                                [
                                  _c(
                                    "p",
                                    { staticStyle: { "font-size": "12px" } },
                                    [
                                      _vm._v("สอบถามรายละเอียดเพิ่มเติม"),
                                      _c("b-img", {
                                        attrs: {
                                          src:
                                            "/static/img/recruitment/line_contact.png",
                                          width: "70",
                                          alt: "..."
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-md-6 col-lg-6 p-2" },
              [
                _c("b-img", {
                  attrs: {
                    src: "/static/img/recruitment/maid_service.png",
                    fluid: "",
                    alt: "..."
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-center my-2" },
                  [
                    _c("h3", [_vm._v("ติดต่อเรา")]),
                    _vm._v(" "),
                    _c("b-img", {
                      attrs: {
                        src: "/static/img/recruitment/qr_recruitment.png",
                        fluid: "",
                        alt: "..."
                      }
                    }),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _vm._m(3)
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "p-1", attrs: { id: "what-a-service" } }, [
          _c("section", { staticClass: "card" }, [
            _c("div", { staticClass: "row no-gutters" }, [
              _c("div", { staticClass: "col-12 col-md-6 col-lg-6 pl-4 pt-4" }, [
                _c("div", { class: _vm.$mq.phone ? "text-center" : "" }, [
                  _c("h2", { staticClass: "text-info" }, [
                    _vm._v(
                      "\n                                Our Vision\n                            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-info" }, [
                    _vm._v(
                      '\n                                "เป็นหนึ่งด้านการหาผู้ช่วยที่มีคุณภาพด้วยบริการที่เป็นมาตรฐาน"\n                            '
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(4),
                _vm._v(" "),
                _vm._m(5),
                _vm._v(" "),
                _vm._m(6)
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-md-6 col-lg-6 p-2" },
                [
                  _c("b-img", {
                    attrs: {
                      src: _vm.$mq.phone
                        ? "/static/img/recruitment/maid_ph1_mq.png"
                        : "/static/img/recruitment/maid_ph1.png",
                      fluid: "",
                      alt: "..."
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "card pb-3" }, [
            _vm._m(7),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "row no-gutters" }, [
              _c(
                "div",
                { staticClass: "col-12 col-md-6 col-lg-6 p-2" },
                [
                  _c("b-img", {
                    attrs: {
                      src: _vm.$mq.phone
                        ? "/static/img/recruitment/maid_ph2_mq.png"
                        : "/static/img/recruitment/maid_ph2.png",
                      fluid: "",
                      alt: "..."
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-md-6 col-lg-6 pl-2" }, [
                _vm._m(8),
                _vm._v(" "),
                _vm._m(9),
                _vm._v(" "),
                _vm._m(10),
                _vm._v(" "),
                _vm._m(11),
                _vm._v(" "),
                _vm._m(12),
                _vm._v(" "),
                _vm._m(13),
                _vm._v(" "),
                _c("div", { staticClass: "mt-3 ml-2" }, [
                  _c("p", [
                    _vm._v(
                      "\n                                หลังจากการประกาศหาคุณแม่บ้านในระบบที่รับเงื่อนไข\n                                และรายละเอียดงานของคุณลูกค้าได้ ฝ่ายจัดหาจะจัดส่งโปรไฟล์\n                                คุณแม่บ้านที่สมัครและสนใจงานประจำของคุณลูกค้าให้ได้เลือก และนัดสัมภาษณ์งานต่อไป\n                                "
                    ),
                    !_vm.$mq.phone
                      ? _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "scroll-to",
                                rawName: "v-scroll-to",
                                value: {
                                  el: "#form-maid-recruitment",
                                  offset: _vm.$mq.phone ? -110 : -130
                                },
                                expression:
                                  "{el:'#form-maid-recruitment', offset: $mq.phone ? -110 : -130}"
                              }
                            ],
                            attrs: { href: "#" }
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm btn-info",
                                attrs: { type: "button" }
                              },
                              [
                                _vm._v(
                                  "\n                                        ส่งคำขอรับบริการจัดหา\n                                    "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.$mq.phone
                    ? _c("div", { staticClass: "text-center" }, [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "scroll-to",
                                rawName: "v-scroll-to",
                                value: {
                                  el: "#form-maid-recruitment",
                                  offset: _vm.$mq.phone ? -110 : -130
                                },
                                expression:
                                  "{el:'#form-maid-recruitment', offset: $mq.phone ? -110 : -130}"
                              }
                            ],
                            attrs: { href: "#" }
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm btn-info",
                                attrs: { type: "button" }
                              },
                              [
                                _vm._v(
                                  "\n                                        ส่งคำขอรับบริการจัดหา\n                                    "
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("section", [
            _c("div", { staticClass: "text-center my-2" }, [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "scroll-to",
                      rawName: "v-scroll-to",
                      value: {
                        el: "#form-maid-recruitment",
                        offset: _vm.$mq.phone ? -110 : -130
                      },
                      expression:
                        "{el:'#form-maid-recruitment', offset: $mq.phone ? -110 : -130}"
                    }
                  ],
                  staticClass: "text-center mb-2",
                  attrs: { href: "#" }
                },
                [
                  _vm._m(14),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticStyle: { color: "#32a2b8" } }, [
                    _vm._v("BACK TO TOP")
                  ])
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "sweet-modal",
          {
            ref: "modalRequestDetail",
            attrs: { width: !_vm.$mq.phone ? "80%" : "" }
          },
          [
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _c("b-img", {
                  attrs: {
                    src: "/static/img/recruitment/logo_BM.png",
                    width: "300",
                    alt: "..."
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _c("h2", { staticClass: "text-info" }, [
                _vm._v(
                  "\n                    รหัสคำขอบริการจัดหา REF ID : " +
                    _vm._s(_vm.jobPost ? _vm.jobPost.ref_id : "") +
                    "\n                    "
                ),
                _vm.jobPost && _vm.jobPost.ref_id
                  ? _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "clipboard",
                            rawName: "v-clipboard:copy",
                            value: _vm.jobPost.ref_id,
                            expression: "jobPost.ref_id",
                            arg: "copy"
                          }
                        ],
                        staticClass: "h5 btn btn-outline-secondary",
                        staticStyle: { cursor: "pointer" },
                        attrs: { type: "button" }
                      },
                      [
                        _c("i", { staticClass: "fa fa-clone mb-1" }, [
                          _vm._v("คัดลอก")
                        ])
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("ขอขอบคุณที่สนใจใช้บริการจัดหาคุณแม่บ้านประจำ BeNeat")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("ทางเจ้าหน้าที่จะติดต่อกลับท่าน ภายใน 24 ชั่วโมง")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "หรือถ้าหากต้องการสอบถามเพิ่มเติมสามารถแจ้งรหัสคำขอบริการจัดหาได้ที่ Line Official ได้เลยค่ะ"
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c("a", { attrs: { href: "https://lin.ee/2oiTubz" } }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn rounded-pill",
                      staticStyle: { "background-color": "#39cd02" }
                    },
                    [
                      _c("div", { staticClass: "d-flex" }, [
                        _c("img", {
                          staticClass: "img-fluid rounded-circle",
                          attrs: {
                            src: "/static/img/floatingButton/line.png",
                            "data-platform": "line",
                            width: "48"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-white" }, [
                          _c("span", { staticClass: "font-weight-bolder h3" }, [
                            _vm._v("Click !!! ")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            " กดเพื่อแอดไลน์\n                                "
                          )
                        ])
                      ])
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mt-3",
                staticStyle: { "background-color": "#3ce5ffba" }
              },
              [
                _vm._v(
                  "\n                Contact : 063-297-0492 หรือ 062-196-6190 | เวลาทำการวันจันทร์ - วันเสาร์  |  เวลา 08.30 - 17.30 น.\n            "
                )
              ]
            )
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("footer", { staticClass: "footer-section" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-4" }, [
          _c("h2", [_vm._v("ลูกค้า")]),
          _vm._v(" "),
          _vm._m(15),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "scroll-to",
                  rawName: "v-scroll-to",
                  value: {
                    el: "#form-maid-recruitment",
                    offset: _vm.$mq.phone ? -110 : -130
                  },
                  expression:
                    "{el:'#form-maid-recruitment', offset: $mq.phone ? -110 : -130}"
                }
              ],
              attrs: { href: "#" }
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-info",
                  attrs: { type: "button" }
                },
                [
                  _vm._v(
                    "\n                        ส่งคำขอรับบริการจัดหา\n                    "
                  )
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4" }, [
          _c("h2", [_vm._v(_vm._s(_vm.$t("message.footer.contact_us")))]),
          _vm._v(" "),
          _c("ul", { staticClass: "list-unstyled footer-list" }, [
            _c("li", [
              _c("i", { staticClass: "fas fa-map-marker-alt" }),
              _vm._v(" \n                    "),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("message.footer.address.04"))
                }
              })
            ])
          ]),
          _vm._v(" "),
          _vm._m(16),
          _vm._v(" "),
          _vm._m(17)
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4 miku__footer" }, [
          _c("h2", [_vm._v("ผู้สนใจสมัครงาน")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("สนใจทักไลน์ไอดี : @jobmaid ( มี @ ข้างหน้าด้วยนะคะ )")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _vm._m(18),
              _vm._v(" "),
              _c("b-img", {
                attrs: {
                  src: "/static/img/recruitment/qr_recruitment.png",
                  fluid: "",
                  alt: "...",
                  width: "100"
                }
              }),
              _vm._v(" "),
              _vm._m(19)
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(20)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "customer-service-header" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 p-xl-0 p-sm-2 small" }, [
          _c("i", { staticClass: "fas fa-phone" }),
          _vm._v(" "),
          _c("a", { attrs: { href: "tel:+66632970492" } }, [
            _vm._v("063-297-0492")
          ]),
          _vm._v(",\n                    "),
          _c("a", { attrs: { href: "tel:+66621966190" } }, [
            _vm._v("062-196-6190")
          ]),
          _vm._v(" "),
          _c("a", { attrs: { href: "https://lin.ee/2oiTubz" } }, [
            _c("img", {
              staticClass: "img-fluid",
              attrs: {
                src: "/static/img/floatingButton/line.png",
                "data-platform": "line",
                width: "18"
              }
            }),
            _vm._v("@mikuagency")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center my-2" }, [
      _c("p", { staticClass: "h4 font-weight-bolder" }, [
        _vm._v("คำขอรับบริการ")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "h4 font-weight-bolder" }, [
        _vm._v("บริการจัดหาแม่บ้าน ผู้ช่วยประจำบ้าน")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "text-info" }, [
      _c("a", { attrs: { href: "tel:063-297-0492" } }, [
        _vm._v("063-297-0492")
      ]),
      _vm._v("  หรือ "),
      _c("a", { attrs: { href: "tel:062-196-6190" } }, [_vm._v("062-196-6190")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-1" }, [
      _c("a", { attrs: { href: "https://lin.ee/2oiTubz" } }, [
        _c(
          "button",
          { staticClass: "btn btn-success", attrs: { type: "button" } },
          [
            _vm._v(
              "\n                                    LINE ID : @mikuagency\n                                "
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mr-3" }, [
      _c("div", { staticClass: "d-flex" }, [
        _c("div", { staticClass: "number__circle font-weight-bolder" }, [
          _vm._v("1")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "font-weight-bolder text__middle pl-2" }, [
          _vm._v("สรรหาตามคุณสมบัติด้วยความรวดเร็ว")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text__left pl-2" }, [
        _vm._v(
          "ทำหน้าที่สรรหาผู้ช่วยให้ตรงตามคุณสมบัติที่คุณลูกค้ากำหนด ด้วยความรวดเร็ว"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mr-2" }, [
      _c("div", { staticClass: "d-flex" }, [
        _c("span", { staticClass: "number__circle font-weight-bolder" }, [
          _vm._v("2")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "font-weight-bolder text__middle pl-2" }, [
          _vm._v("เตรียมความพร้อมก่อนเริ่มงาน")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text__left pl-2" }, [
        _vm._v(
          "ตรวจสอบประวัติอาชญากรรม และตรวจสุขภาพตามความประสงค์ของคุณลูกค้า"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mr-2" }, [
      _c("div", { staticClass: "d-flex" }, [
        _c("span", { staticClass: "number__circle font-weight-bolder" }, [
          _vm._v("3")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "font-weight-bolder text__middle pl-2" }, [
          _vm._v("การันตีคุณภาพ")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text__left pl-2" }, [
        _vm._v("รับประกันความพึงพอใจ สามารถเปลี่ยนผู้ช่วยได้")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center pt-3" }, [
      _c("h3", [_vm._v("ระบุคุณสมบัติคุณแม่บ้านที่ต้องการได้")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-2 ml-2" }, [
      _c("div", { staticClass: "d-flex" }, [
        _c("i", {
          staticClass: "fa fa-check-square fa-1x padding__icon text-success",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "ml-1 font-weight-bolder text__middle" }, [
          _vm._v("ประเภท : (บ้าน/คอนโด/สำนักงาน/โรงแรม)")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-2 ml-2" }, [
      _c("div", { staticClass: "d-flex" }, [
        _c("i", {
          staticClass: "fa fa-check-square fa-1x padding__icon text-success",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "ml-1 font-weight-bolder text__middle" }, [
          _vm._v("วันเวลาที่ปฏิบัติงาน / พักอาศัย / ไป-กลับ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-2 ml-2" }, [
      _c("div", { staticClass: "d-flex" }, [
        _c("i", {
          staticClass: "fa fa-check-square fa-1x padding__icon text-success",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "ml-1 font-weight-bolder text__middle" }, [
          _vm._v("เงินเดือน สวัสดิการอื่นๆ และ วันหยุด")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-2 ml-2" }, [
      _c("div", { staticClass: "d-flex" }, [
        _c("i", {
          staticClass: "fa fa-check-square fa-1x padding__icon text-success",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "ml-1 font-weight-bolder text__middle" }, [
          _vm._v("จังหวัด/เขต/แขวง")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-2 ml-2" }, [
      _c("div", { staticClass: "d-flex" }, [
        _c("i", {
          staticClass: "fa fa-check-square fa-1x padding__icon text-success",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "ml-1 font-weight-bolder text__middle" }, [
          _vm._v("รายละเอียดเกี่ยวกับงานที่ต้องทำ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-2 ml-2" }, [
      _c("div", { staticClass: "d-flex" }, [
        _c("i", {
          staticClass: "fa fa-check-square fa-1x padding__icon text-success",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "ml-1 font-weight-bolder text__middle" }, [
          _vm._v(
            "รายละเอียดงานอื่นๆ ที่ต้องการ เช่น ทำอาหาร, รีดผ้า, ซักผ้า, รักสัตว์, พี่เลี้ยงเด็ก, ดูแลผู้สูงอายุ ฯลฯ"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-info mt-3",
        staticStyle: { "border-radius": "25px" },
        attrs: { type: "button" }
      },
      [_c("i", { staticClass: "fa fa-chevron-up fa-2x" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("รายละเอียดจัดหา "),
      _c("br"),
      _vm._v("ประเภทการให้บริการ "),
      _c("br"),
      _vm._v("เงื่อนไขการให้บริการ "),
      _c("br"),
      _vm._v(" การระบุคุณสมบัติคุณแม่บ้าน")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "p-xl-0 p-sm-2" }, [
      _c("i", { staticClass: "fas fa-phone" }),
      _vm._v(" "),
      _c("a", { attrs: { href: "tel:+66632970492" } }, [
        _vm._v("063-297-0492")
      ]),
      _vm._v(",\n                    "),
      _c("a", { attrs: { href: "tel:+66621966190" } }, [_vm._v("062-196-6190")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pt-2" }, [
      _c(
        "a",
        {
          attrs: {
            href: "https://www.messenger.com/t/beneatco/",
            target: "_blank"
          }
        },
        [
          _c("img", {
            attrs: {
              height: "38",
              alt: "FB Messenger BeNeat",
              src: "/static/img/btn-fb-messenger.png"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://line.me/R/ti/p/%40hnk7011n",
            target: "_blank"
          }
        },
        [
          _c("img", {
            attrs: {
              height: "38",
              alt: "Line BeNeat",
              src: "/static/img/btn-line.png"
            }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "p-xl-0 p-sm-2" }, [
      _c("i", { staticClass: "fas fa-phone" }),
      _vm._v(" "),
      _c("a", { attrs: { href: "tel:+66632970492" } }, [
        _vm._v("063-297-0492")
      ]),
      _vm._v(",\n                        "),
      _c("a", { attrs: { href: "tel:+66621966190" } }, [_vm._v("062-196-6190")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-1 blink" }, [
      _c("a", { attrs: { href: "https://lin.ee/2oiTubz" } }, [
        _c(
          "button",
          { staticClass: "btn btn-success", attrs: { type: "button" } },
          [
            _vm._v(
              "\n                                LINE ID : @mikuagency\n                            "
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _vm._v(
          "\n                Copyright © 2024 by BeNeat Co.,Ltd. All right reserved.\n            "
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fa88f1f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fa88f1f","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/recruitment/Index.vue
// module id = 2445
// module chunks = 0